import { del } from 'utils/http/del';

import type { CmsApiReactionContext } from './types/CmsApiReactionContext';

export async function cmsApiDeleteReaction(
  pageId: string,
): Promise<CmsApiReactionContext> {
  return del<CmsApiReactionContext>(
    `/data/website/reactions/cms-pages/${pageId}`,
  );
}
